import React from "react";
import { Link } from "react-router-dom";

function Challenge() {
  return (
    <div class="main challenge">
      <section class="maintext">
        <h3><b>Coming Soon</b></h3>
        <Link to="/">
          <button className="nav-button">Back to Home</button>
        </Link>
      </section>
      <div className="floating-sidebar">
        <ul>
          <li><a href="/image"><button>Generate</button></a></li>
          <li><a href="/chat"><button>Visit</button></a></li>
          <li><a href="/scenario"><button>Play</button></a></li>
          <li><a href="/challenge"><button>Versus</button></a></li>
        </ul>
      </div>
    </div>
  );
}

export default Challenge;
